import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import { sinhVienApi } from "../../../api/category/sinhVienApi";
import { mucThuKhacSinhVienApi } from "../../../api/chung-tu/mucThuKhacSinhVienApi";
import { IMucThuKhacSinhVienSaveRequest } from "../../../model/request/chung-tu/IMucThuKhacSinhVienSaveRequest";
import { IMucThuKhacSinhVienSelectByLopsRequest } from "../../../model/request/chung-tu/IMucThuKhacSinhVienSelectByLopsRequest";
import { IMucThuKhacSinhVienUpdateSoTienRequest } from "../../../model/request/chung-tu/IMucThuKhacSinhVienUpdateSoTienRequest";
import { IIdsRequest } from "../../../model/request/IIdsRequest";
import { IProcessRequest } from "../../../model/request/IProcessRequest";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";

import {
  eMucThuActionIds,
  IMucThuActionTypes,
} from "../../action-types/muc-thu/IMucThuActionTypes";
import { rootActions } from "../../actions/rootActions";
import { ISinhVienSelectByLopsRequest } from "../../../model/request/sinh-vien/ISinhVienSelectByLopsRequest";

export function* mucThuSaga(): any {
  yield takeLatest(eMucThuActionIds.LOAD_HOCSINH_START, loadWorker);
  yield takeLatest(eMucThuActionIds.LOAD_MUCTHUKHAC_START, loadMucThuWorker);
  yield takeLatest(
    eMucThuActionIds.CREATE_MUCTHUKHAC_START,
    createMucThuKhacStart
  );
  yield takeEvery(eMucThuActionIds.DUYET_MUCTHUKHAC_START, duyetMucThuStart);
  yield takeEvery(
    eMucThuActionIds.HUYDUYET_MUCTHUKHAC_START,
    huyDuyetMucThuStart
  );
  yield takeEvery(
    eMucThuActionIds.DELETE_MUCTHUKHAC_START,
    deleteMucThuKhacStart
  );
  yield takeEvery(eMucThuActionIds.UPDATE_MUCTHUKHAC_START, updateSoTienStart);
  yield takeLatest(eMucThuActionIds.IMPORT_START, importStart);
  yield takeLatest(eMucThuActionIds.SAVE_IMPORT_START, saveImportStart);
  yield takeLatest(eMucThuActionIds.IMPORT_HUYDUYET_START, importHuyDuyetStart);
  yield takeLatest(
    eMucThuActionIds.SAVE_IMPORT_HUYDUYET_START,
    saveImportHuyDuyetStart
  );
}

function* loadWorker(action: IMucThuActionTypes): any {
  const res: IBaseRespone = yield call(
    sinhVienApi.SelectByLops,
    action.payload as ISinhVienSelectByLopsRequest
  );
  if (res.is_success) {
    yield put(rootActions.mucThu.mucThu.LOAD_HOCSINH_SUCCESS(res.data));
  } else {
    yield put(
      rootActions.mucThu.mucThu.LOAD_HOCSINH_ERRR(res.message ?? "Có lỗi")
    );
  }
}

function* loadMucThuWorker(action: IMucThuActionTypes): any {
  const res: IBaseRespone = yield call(
    mucThuKhacSinhVienApi.SelectByLops,
    action.payload as IMucThuKhacSinhVienSelectByLopsRequest
  );
  if (res.is_success) {
    yield put(rootActions.mucThu.mucThu.LOAD_MUCTHUKHAC_SUCCESS(res.data));
  } else {
    yield put(
      rootActions.mucThu.mucThu.LOAD_MUCTHUKHAC_ERRR(res.message ?? "Có lỗi")
    );
  }
}

function* createMucThuKhacStart(action: IMucThuActionTypes): any {
  const res: IBaseRespone = yield call(
    mucThuKhacSinhVienApi.Create,
    action.payload as IMucThuKhacSinhVienSaveRequest
  );
  if (res.is_success) {
    yield put(rootActions.mucThu.mucThu.CREATE_MUCTHUKHAC_SUCCESS(res.data));
  } else {
    yield put(
      rootActions.mucThu.mucThu.CREATE_MUCTHUKHAC_ERRR(res.message ?? "Có lỗi")
    );
  }
}

function* duyetMucThuStart(action: IMucThuActionTypes): any {
  const res: IBaseRespone = yield call(
    mucThuKhacSinhVienApi.DuyetAsync,
    action.payload as IProcessRequest<number[]>
  );
  if (res.is_success) {
    yield put(rootActions.mucThu.mucThu.DUYET_MUCTHUKHAC_SUCCESS(res.data));
  } else {
    yield put(
      rootActions.mucThu.mucThu.DUYET_MUCTHUKHAC_ERRR(res.message ?? "Có lỗi")
    );
  }
}

function* huyDuyetMucThuStart(action: IMucThuActionTypes): any {
  const request = action.payload as IProcessRequest<number[]>;
  const res: IBaseRespone = yield call(
    mucThuKhacSinhVienApi.HuyDuyetAsync,
    request
  );
  if (res.is_success) {
    yield put(rootActions.mucThu.mucThu.HUYDUYET_MUCTHUKHAC_SUCCESS(res.data));
    yield put(
      rootActions.thuPhi.thuPhi.LOAD_MUC_THU_KHAC_START_BY_MUCTHUID(
        request.payload
      )
    );
  } else {
    yield put(
      rootActions.mucThu.mucThu.HUYDUYET_MUCTHUKHAC_ERRR(
        res.message ?? "Có lỗi"
      )
    );
  }
}

function* deleteMucThuKhacStart(action: IMucThuActionTypes): any {
  const res: IBaseRespone = yield call(
    mucThuKhacSinhVienApi.Deletes,
    action.payload as IIdsRequest
  );
  if (res.is_success) {
    yield put(rootActions.mucThu.mucThu.DELETE_MUCTHUKHAC_SUCCESS(res.data));
  } else {
    yield put(
      rootActions.mucThu.mucThu.DELETE_MUCTHUKHAC_ERRR(res.message ?? "Có lỗi")
    );
  }
}

function* updateSoTienStart(action: IMucThuActionTypes): any {
  const res: IBaseRespone = yield call(
    mucThuKhacSinhVienApi.UpdateSoTien,
    action.payload as IMucThuKhacSinhVienUpdateSoTienRequest
  );
  if (res.is_success) {
    yield put(rootActions.mucThu.mucThu.UPDATE_MUCTHUKHAC_SUCCESS(res.data));
  } else {
    yield put(
      rootActions.mucThu.mucThu.UPDATE_MUCTHUKHAC_ERRR(res.message ?? "Có lỗi")
    );
  }
}

function* importStart(action: IMucThuActionTypes): any {
  const res: IBaseRespone = yield call(
    mucThuKhacSinhVienApi.Import,
    action.payload as FormData
  );
  if (res.is_success) {
    yield put(rootActions.mucThu.mucThu.IMPORT_SUCESS(res.data));
  } else {
    yield put(rootActions.mucThu.mucThu.IMPORT_ERROR(res.message ?? "Có lỗi"));
  }
}

function* saveImportStart(action: IMucThuActionTypes): any {
  const res: IBaseRespone = yield call(
    mucThuKhacSinhVienApi.SaveImport,
    action.payload as string
  );
  if (res.is_success) {
    yield put(rootActions.mucThu.mucThu.SAVE_IMPORT_SUCESS(res.data));
  } else {
    yield put(
      rootActions.mucThu.mucThu.SAVE_IMPORT_ERROR(res.message ?? "Có lỗi")
    );
  }
}

function* importHuyDuyetStart(action: IMucThuActionTypes): any {
  const res: IBaseRespone = yield call(
    mucThuKhacSinhVienApi.ImportHuyDuyet,
    action.payload as FormData
  );
  if (res.is_success) {
    yield put(rootActions.mucThu.mucThu.IMPORT_HUYDUYET_SUCESS(res.data));
  } else {
    yield put(
      rootActions.mucThu.mucThu.IMPORT_HUYDUYET_ERROR(res.message ?? "Có lỗi")
    );
  }
}

function* saveImportHuyDuyetStart(action: IMucThuActionTypes): any {
  const res: IBaseRespone = yield call(
    mucThuKhacSinhVienApi.SaveImportHuyDuyet,
    action.payload as string
  );
  if (res.is_success) {
    yield put(rootActions.mucThu.mucThu.SAVE_IMPORT_HUYDUYET_SUCESS(res.data));
  } else {
    yield put(
      rootActions.mucThu.mucThu.SAVE_IMPORT_HUYDUYET_ERROR(
        res.message ?? "Có lỗi"
      )
    );
  }
}
